<template>
  <div>
    <modal name="editCampo" height="auto" width="1200" :scrollable="true" :clickToClose="false">
      <CamposDisponiveis
          :campos="tipo.de"
          nome="camposDisponiveisDe"
          :onSelect="alterarCampoDe"
      />
      <CamposDisponiveis
          :campos="tipo.para"
          nome="camposDisponiveisPara"
          :onSelect="alterarCampoPara"
      />
      <CloseModal :close="close"/>

      <div class="modalbox">
        <div class="modalbox-content">
          <div class="modal-header-info">
            <div class="header-title">{{ tipo.titulo }}</div>
            <div class="header-desc">
              Chave: <code>{{ tipo.chave }}</code>
            </div>
          </div>

          <div v-if="campos.length === 0" class="empty-state">
            <div class="empty-icon">
              <fa-icon icon="cubes" />
            </div>
            <div class="empty-text">Nenhum campo mapeado</div>
            <div class="empty-desc">Clique no botao abaixo para mapear o primeiro campo.</div>
          </div>

          <div
              v-for="(campo, idx) in campos"
              :key="idx"
              class="campo-card"
              :class="{ 'campo-card--invalid': !isCampoValido(campo) }"
          >
            <div class="campo-card-header">
              <span class="campo-ordem-badge">#{{ idx + 1 }}</span>
              <span class="campo-label-preview" v-if="campo.de && campo.para">
                {{ campo.de }} &rarr; {{ campo.para }}
              </span>
              <span class="campo-label-preview campo-label-preview--empty" v-else>Mapeamento incompleto</span>
              <button
                  type="button"
                  class="btn-remove"
                  @click="onRemoveCampo(idx)"
                  title="Remover campo"
              >
                <fa-icon icon="trash-alt" />
              </button>
            </div>

            <div class="campo-card-body">
              <div class="row form-group">
                <div class="col-md-3">
                  <label class="field-label">{{ campoDe(campo.de) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': !campo.de || campo.de.trim().length === 0 }"
                      type="text"
                      v-model="campo.de"
                  />
                  <button v-if="possuiCamposDe" class="btn-selecionar" @click="openModalCamposDisponiveisDe(campo)">
                    Selecionar da lista
                  </button>
                </div>
                <div class="col-md-3">
                  <label class="field-label">{{ campoPara(campo.para) }}</label>
                  <input
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': !campo.para || campo.para.trim().length === 0 }"
                      type="text"
                      v-model="campo.para"
                  />
                  <button v-if="possuiCamposPara" class="btn-selecionar" @click="openModalCamposDisponiveisPara(campo)">
                    Selecionar da lista
                  </button>
                </div>
                <div class="col-md-2">
                  <label class="field-label">Valor padrao</label>
                  <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="campo.valor_padrao"
                  />
                </div>
                <div class="col-md-1">
                  <label class="field-label">Formato</label>
                  <select v-model="campo.conversao" class="form-control form-control-sm">
                    <option v-for="(value, label) in formatos" :key="label" :value="value">
                      {{ label }}
                    </option>
                  </select>
                </div>
                <div v-if="validaFormato(campo)" class="col-md-1">
                  <label class="field-label">Inverte sinal</label>
                  <select v-model="campo.inverte_sinal" class="form-control form-control-sm">
                    <option value="1">Sim</option>
                    <option value="0">Nao</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="field-label">Incluir se nulo</label>
                  <select v-model="campo.incluir_se_nulo" class="form-control form-control-sm">
                    <option value="1">Sim</option>
                    <option value="0">Nao</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="info-text" v-if="campos.length > 0">
            Os campos acima listados serao alterados ou adicionados (caso nao existam no modelo padrao).
            O valor sera obtido atraves do campo "DE" e enviado para integracao atraves do campo "PARA".
          </div>
        </div>
      </div>

      <div class="modal-footer-bar">
        <CButton color="success" size="sm" @click="onAdd">
          <fa-icon icon="plus" /> Incluir campo
        </CButton>
        <div class="footer-spacer"></div>
        <CButton variant="outline" color="secondary" @click="close">
          Cancelar
        </CButton>
        <CButton color="primary" :disabled="!camposValidos" @click="handleSubmit">
          Salvar
        </CButton>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import CamposDisponiveis from "./CamposDisponiveis";
import { isEmpty } from "lodash";

const campoMapeado = (tipo) => ({
  'de': '',
  'para': '',
  'conversao': null,
  'inverte_sinal': 0,
  'incluir_se_nulo': 1,
  'valor_padrao': '',
  'ordem': 1,
  tipo
});

export default {
  name: "Edit",
  components: {
    CamposDisponiveis,
    CloseModal,
  },
  props: [
    'close',
    'tipo',
    'campos',
    'formatos',
    'onSubmit',
  ],
  data() {
    return {
      campoEmEdicao: {}
    }
  },
  computed: {
    camposValidos() {
      let valido = true;

      this.campos.forEach((campo) => {
        if (!campo.de || campo.de.trim().length === 0 || !campo.para || campo.para.trim().length === 0) {
          valido = false;
        }
      });

      return valido;
    },
    possuiCamposDe() {
      return !isEmpty(this.tipo.de)
    },
    possuiCamposPara() {
      return !isEmpty(this.tipo.para)
    },
  },
  methods: {
    isCampoValido(campo) {
      return campo.de && campo.de.trim().length > 0
          && campo.para && campo.para.trim().length > 0;
    },
    validaFormato(campo) {
      return campo.conversao == 'int' || campo.conversao == 'float'
    },
    alterarCampoDe(novoValor) {
      this.campoEmEdicao.de = novoValor;
    },
    alterarCampoPara(novoValor) {
      this.campoEmEdicao.para = novoValor;
    },
    openModalCamposDisponiveisDe(campo) {
      this.campoEmEdicao = campo;
      this.$modal.show('camposDisponiveisDe');
    },
    openModalCamposDisponiveisPara(campo) {
      this.campoEmEdicao = campo;
      this.$modal.show('camposDisponiveisPara');
    },
    campoDe(nomeCampo) {
      return 'De: ' + (this.tipo.de && this.tipo.de[nomeCampo] ? this.tipo.de[nomeCampo] : 'Campo customizado');
    },
    campoPara(nomeCampo) {
      return 'Para: ' + (this.tipo.para && this.tipo.para[nomeCampo] ? this.tipo.para[nomeCampo] : 'Campo customizado');
    },
    onAdd() {
      this.campos.push(campoMapeado(this.tipo.chave));
    },
    onRemoveCampo(index) {
      this.campos.splice(index, 1)
    },
    handleSubmit() {
      this.onSubmit(
        this.campos,
        this.tipo.chave
      )
    }
  }
}
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #3a3e81;
}

.header-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 4px;
}

.header-desc code {
  font-size: 11px;
  color: #344054;
  background: #f2f4f7;
  padding: 1px 5px;
  border-radius: 3px;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #f2f2f8;
  color: #3a3e81;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.empty-text {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}

.empty-desc {
  font-size: 13px;
  color: #667085;
  margin-top: 4px;
}

/* Campo card */
.campo-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.campo-card:hover {
  border-color: #d0d5dd;
}

.campo-card--invalid {
  border-color: #fda29b;
}

.campo-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 10px 10px 0 0;
}

.campo-ordem-badge {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  background: #e9ecef;
  padding: 1px 6px;
  border-radius: 4px;
}

.campo-label-preview {
  font-weight: 500;
  font-size: 13px;
  color: #344054;
  flex: 1;
}

.campo-label-preview--empty {
  color: #98a2b3;
  font-style: italic;
}

.btn-remove {
  background: none;
  border: none;
  color: #98a2b3;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.15s;
  font-size: 13px;
}

.btn-remove:hover {
  color: #d92d20;
  background: #fef3f2;
}

.campo-card-body {
  padding: 12px 14px;
}

.campo-card-body .form-group {
  margin-bottom: 8px;
}

/* Field labels */
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Botao selecionar da lista */
.btn-selecionar {
  background: none;
  border: 1px solid #dddce9;
  color: #3a3e81;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 4px;
  transition: all 0.15s;
}

.btn-selecionar:hover {
  background: #f2f2f8;
}

/* Info text */
.info-text {
  font-size: 12px;
  color: #667085;
  margin-top: 12px;
  padding: 10px 14px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

/* Modal footer */
.modal-footer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
}

.footer-spacer {
  flex: 1;
}
</style>
